import pathfinder from '@fiverr-private/pathfinder';
import { PATHFINDER } from '../../utils';

export const getLogoMakerIdeasPath = ({ tag, tagType: type }) =>
    pathfinder(PATHFINDER.LOGO_MAKER_IDEAS_PAGE, { type, tag });
